import {
  S3Client,
  PutObjectCommand,
  ListObjectsV2Command,
  GetObjectCommand,
  DeleteObjectCommand,
  CopyObjectCommand,
} from "@aws-sdk/client-s3";

const AWS_REGION = import.meta.env.VITE_AWS_REGION;
const AWS_ACCESS_KEY_ID = import.meta.env.VITE_AWS_ACCESS_KEY_ID;
const AWS_SECRET_ACCESS_KEY = import.meta.env.VITE_AWS_SECRET_ACCESS_KEY;
const S3_BUCKET = import.meta.env.VITE_AWS_S3_BUCKET;

export const s3 = new S3Client({
  region: AWS_REGION,
  credentials: {
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
  },
});

/* Datei-Validierung */
export function validateInquiryFiles(files: File[]) {
  for (const file of files) {
    if (!(file instanceof File)) {
      return { ok: false, error: "Ungültige Datei" };
    }
    if (file.size > 20 * 1024 * 1024) {
      return { ok: false, error: "Datei ist größer als 20 MB" };
    }
  }
  return { ok: true };
}

/* Upload */
export async function uploadInquiryFiles(
  files: File[],
  type: "nurse" | "employer" | "contact"
): Promise<string[]> {
  const uploadedPaths: string[] = [];

  for (const file of files) {
    const key = `inquiries/uploads/${type}/${Date.now()}-${file.name}`;

    const arrayBuffer = await file.arrayBuffer();
    await s3.send(
      new PutObjectCommand({
        Bucket: S3_BUCKET,
        Key: key,
        Body: arrayBuffer,
        ContentType: file.type,
      })
    );

    uploadedPaths.push(key);
  }

  return uploadedPaths;
}

/* Download */
export async function downloadS3File(type: string, fileName: string) {
  const key = `inquiries/downloads/${type}/${fileName}`;

  const response = await s3.send(
    new GetObjectCommand({
      Bucket: S3_BUCKET,
      Key: key,
    })
  );

  const arrayBuffer = await response.Body!.arrayBuffer();
  const blob = new Blob([new Uint8Array(arrayBuffer)]);
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
}

/* Preview */
export async function previewS3File(type: string, fileName: string) {
  const key = `inquiries/downloads/${type}/${fileName}`;

  const response = await s3.send(
    new GetObjectCommand({
      Bucket: S3_BUCKET,
      Key: key,
    })
  );

  const arrayBuffer = await response.Body!.arrayBuffer();
  const blob = new Blob([new Uint8Array(arrayBuffer)]);
  const url = URL.createObjectURL(blob);

  window.open(url, "_blank");
}